import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import { Col, ConfigProvider, Row } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import RegistrationUniversityCollapse from "./RegistrationUniversityCollapse";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import AddRegistrationRequest from "./AddRegistrationRequest";
import {
  getAllUniversitiesScholarship,
  getUniversities,
} from "../../../../apis/actions/scholarship.actions";

const RegistrationUniversityRequest = ({
  selectedFilter,
  filterOrphans,
  state,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { data: scholarshipsUniversity, loading } = useSelector(
    (state: RootState) => state?.scholarship?.scholarshipsUniversity
  );
  const { universities, TotalUniversityScholars } = useSelector(
    (state: RootState) => state?.scholarship
  );

  useEffect(() => {
    dispatch(getBeneficiaryDetails());
    dispatch(getUniversities());
  }, [dispatch]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getAllUniversitiesScholarship({
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
        partner_id: selectedFilter,
      })
    );
  }, [dispatch, currentPage, state, selectedFilter]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row gutter={8} style={{ marginBottom: "3rem" }}>
          <Col
            xxl={4}
            xl={5}
            lg={5}
            md={5}
            sm={24}
            xs={24}
            style={{ marginTop: "0.4rem" }}
          >
            <PrimaryButton
              onClick={() => setIsModalVisible(true)}
              title="طلب تسجيل"
              className="takaful--add-request-btn"
            />
          </Col>
        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : scholarshipsUniversity?.length === 0 &&
        !selectedFilter &&
        // eslint-disable-next-line eqeqeq
        state.year == "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      ) : scholarshipsUniversity?.length === 0 &&
        (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <RegistrationUniversityCollapse requests={scholarshipsUniversity} />
          </Row>
          <div className="takaful--pagination-container">
            {scholarshipsUniversity &&
              Math.ceil(TotalUniversityScholars) * itemPerPage >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalUniversityScholars) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}

      <AddRegistrationRequest
        beneficiary={filterOrphans}
        universities={universities}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
      />
    </>
  );
};

export default RegistrationUniversityRequest;
